<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-cs-preview-modal"
      :no-header="false"
      :no-footer="true"
      :is-full-size="true"
    >
      <div class="jps-modal-content" v-if="ss">
        <UiCsearchHeader :cs="editstate.cs" />
        <SearchBox :ss="ss" :additional="true" />
        <BaseContainerSpread>
          <UiItemSearchResult :ss="ss" />
        </BaseContainerSpread>
      </div>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import type { BaseModal } from '#components'

const { testCustomSearch } = useItem()

interface Props {
  editstate?: CsEditState
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _editstate: Ref<CsEditState> = ref()
const ss: Ref<SearchStore<Item>> = ref()
const openAwait = async (options?: Props) => {
  setOptionsValue(_editstate, 'editstate', props, options)
  ss.value = useSearch<Item>(
    _editstate.value.cs,
    testCustomSearch(_editstate.value.cs),
    {
      configSyncRoute: false,
    }
  )
  return await modal.value.openAwait()
}
defineExpose({ openAwait })
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.jps-cs-preview-modal {
  .jps-search-box {
    margin-bottom: 1rem;
  }
}
</style>
